import { render, staticRenderFns } from "./WizardStep.vue?vue&type=template&id=18d424f0&scoped=true"
import script from "./WizardStep.vue?vue&type=script&lang=js"
export * from "./WizardStep.vue?vue&type=script&lang=js"
import style0 from "./WizardStep.vue?vue&type=style&index=0&id=18d424f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d424f0",
  null
  
)

export default component.exports